import PageSobre from '../../Components/Page-Sobre-Dr/doutor';
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';

function Sobre() { 
  return (
    <>
      <div id="Sobre">
        <PageSobre />
      </div>
      <div id="Agendamento">
        <Agendamento />
      </div>
      <div id="Footer">
        <Footer />
      </div>
    </>
  );
};

export default Sobre;
